import { render, staticRenderFns } from "./MessageInboxes.vue?vue&type=template&id=0a4af121&scoped=true&"
import script from "./MessageInboxes.vue?vue&type=script&lang=ts&"
export * from "./MessageInboxes.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInboxes.vue?vue&type=style&index=0&id=0a4af121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4af121",
  null
  
)

export default component.exports